import {
	OpeningHoursDayType,
	OpeningHourObject,
	ExceptionDateObject,
	ExceptionPeriod,
	OpeningHoursApi,
	LocationOpeningHoursApi,
} from 'common/types';
import moment from 'moment-timezone';
import { newFirestoreId } from 'common/utils/newRentalUtils';

export const dayTypeOptions: OpeningHoursDayType[] = [
	'allDays',
	'weekDays',
	'weekends',
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday',
];

export const getDefaultTimesWithDayType = (
	dayType: OpeningHoursDayType = 'allDays',
): OpeningHourObject => {
	return {
		dayType,
		openTime: '09:00',
		closeTime: '21:00',
		isClosed: false,
	};
};

export const getDefaultExceptionDateObj = (date: string): ExceptionDateObject => {
	return {
		date,
		openTime: '09:00',
		closeTime: '21:00',
		isClosed: false,
	};
};

export const getNextFreeExceptionDate = (
	exceptionDates: ExceptionDateObject[],
	startDate?: string,
) => {
	const exceptionDatesList = exceptionDates ? exceptionDates.map((dateObj) => dateObj.date) : [];
	let availableDate = startDate ? startDate : moment().format('YYYY-MM-DD');
	while (exceptionDatesList.includes(availableDate)) {
		availableDate = moment(availableDate).add(1, 'day').format('YYYY-MM-DD');
	}
	return availableDate;
};

export const validateExceptionPeriodDates = (
	exceptionPeriod: ExceptionPeriod,
	exceptionPeriodsToValidateAgainst: ExceptionPeriod[],
) => {
	const startDate = moment(exceptionPeriod.startDate);
	const endDate = moment(exceptionPeriod.endDate);

	return !exceptionPeriodsToValidateAgainst.some((period) => {
		return (
			startDate.isSameOrBefore(period.endDate, 'day') &&
			moment(period.startDate).isSameOrBefore(endDate)
		);
	});
};

export const getNewExceptionPeriod = (
	existingPeriods: ExceptionPeriod[],
	locationId: string,
): ExceptionPeriod => {
	const lastExceptionPeriod = existingPeriods[existingPeriods.length - 1];

	const startDate = lastExceptionPeriod
		? moment(lastExceptionPeriod.endDate).add(1, 'day')
		: moment();
	const endDate = moment(startDate).add(1, 'day');

	return {
		id: newFirestoreId(),
		startDate: startDate.format('YYYY-MM-DD'),
		endDate: endDate.format('YYYY-MM-DD'),
		openingHours: {
			defaultTimes: [],
			exceptionDates: [],
			openingHoursWithLocation: {},
			useDefault: true,
		},
		locationId,
	};
};

export const isMainOpeningHours = (
	locationOpeningHours: OpeningHoursApi | LocationOpeningHoursApi,
): locationOpeningHours is OpeningHoursApi => {
	return 'openingHoursWithLocation' in (locationOpeningHours as OpeningHoursApi);
};

export const isLocationOpeningHours = (
	locationOpeningHours: OpeningHoursApi | LocationOpeningHoursApi,
): locationOpeningHours is LocationOpeningHoursApi => {
	return !('openingHoursWithLocation' in (locationOpeningHours as LocationOpeningHoursApi));
};
